export default __webpack_public_path__ + "static/Cart-New-Arrivals-96469f987891b730e7d2f9f8ab490502.webp";